import reducer from "./reducers";


export { default as promotionsOperations } from "./operations";

export default reducer;
